import { Component, OnDestroy, OnInit, ViewChild, inject, output } from '@angular/core';
import { UserDetailUiContext } from '../../../shared/contexts/user-detail-ui.context';
import { BottomNavClearButtonsList, BottomNavService } from '../../../../shared/bottom-nav/bottom-nav.service';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import { cloneDeep, get } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { VoicemailComponent } from '../../voicemail/voicemail.component';
import { BreadcrumbsService } from '../../../../shared/breadcrumbs/breadcrumbs.service';
import { Global360ViewContext } from '../../../../shared/contexts/global-360-view.context';
import { SiteContext } from '../../../shared/contexts/site.context';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'ziro-user-detail-voicemail',
  templateUrl: './user-detail-voicemail.component.html',
  standalone: false,
})
export class UserDetailVoicemailComponent implements OnInit, OnDestroy {
  private userDetailUiContext = inject(UserDetailUiContext);
  private siteContext = inject(SiteContext);
  private bottomNavService = inject(BottomNavService);
  private translateService = inject(TranslateService);
  private breadcrumbsService = inject(BreadcrumbsService);
  private route = inject(ActivatedRoute);
  private global360ViewContext = inject(Global360ViewContext);
  private router = inject(Router);

  readonly voicemailDelete = output<void>();
  @ViewChild(VoicemailComponent) voicemailComponent: VoicemailComponent;

  siteId: number;
  isLoading = true;
  username: string;
  voicemailId: string;
  _icons = ZiroIcons;

  private _subscriptions = new Subscription();

  ngOnInit(): void {
    this.voicemailId = get(this.route, 'snapshot.params.voicemailId');
    const contextSub = combineLatest([this.siteContext.state$, this.userDetailUiContext.state$]).subscribe(([site]) => {
      this.siteId = Number(site.id);
      this.username = this.userDetailUiContext.getCurrentEnduser().ref.username;
      this.isLoading = false;
    });
    this._subscriptions.add(contextSub);
  }

  ngOnDestroy(): void {
    this.bottomNavService.dispatch(new BottomNavClearButtonsList());
    this._subscriptions.unsubscribe();
  }

  onVoicemailSave(): void {
    this.router.navigate(this.voicemailId ? ['../../'] : ['../'], { relativeTo: this.route });
    const global360 = cloneDeep(this.userDetailUiContext.getGlobal360View());
    const voicemailRef = this.voicemailComponent.voicemailRef;
    global360.voicemails.push(voicemailRef);
    this.global360ViewContext._stateSource.next(global360);
  }

  onVoicemailDelete(): void {
    const global360View = cloneDeep(this.userDetailUiContext.getGlobal360View());
    global360View.voicemails.splice(0, 1);
    this.global360ViewContext._stateSource.next(global360View);
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}
